module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/planete22x-2644c72d12672f8235feb4138db3b37d.png";